import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [open,setOpen]=useState(false)
  const { user, logout } = useAuth();
  const navigate=useNavigate();

  const handleLogout = () => {
    // Replace with your auth logic
   logout();
   navigate("/login")
  };

  return (
    <div style={{
      padding: 20,
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid #ccc',
      position: 'relative',
    }}>
      <div></div>
      <div style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
        👤 Admin ▾
        {open && (
          <div style={{
            position: 'absolute',
            right: 20,
            top: 60,
            backgroundColor: 'white',
            boxShadow: '0 0 10px rgba(0,0,0,0.2)',
            padding: '10px 0',
            borderRadius: 4,
            zIndex: 999,
          }}>
            <button
              onClick={handleLogout}
              style={{
                background: 'none',
                border: 'none',
                padding: '10px 20px',
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer',
                color:'black'
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
